import React from 'react'
import PropTypes from 'prop-types'
import { ExclamationTriangleFill } from 'react-bootstrap-icons'
import No from '../../Assets/Images/Login/no.svg'

const containerStyle = {
  position: 'fixed',
  bottom: '24px',
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 99999,
  backgroundColor: '#fff3cd',
  border: '1px solid #ffc107',
  borderRadius: '8px',
  padding: '12px 20px',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  maxWidth: '480px',
  width: '90%',
  pointerEvents: 'none',
}

const iconStyle = {
  color: '#e6a817',
  fontSize: '20px',
  flexShrink: 0,
}

const messageStyle = {
  fontSize: '13px',
  color: '#555',
  flex: 1,
}

const closeStyle = {
  cursor: 'pointer',
  width: '16px',
  flexShrink: 0,
  pointerEvents: 'auto',
}

function NetworkErrorAlert({ open, message, onClose }) {
  if (!open) return null

  return (
    <div style={containerStyle}>
      <ExclamationTriangleFill style={iconStyle} />
      <span style={messageStyle}>{message}</span>
      <img src={No} alt="close" style={closeStyle} onClick={onClose} />
    </div>
  )
}

NetworkErrorAlert.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default NetworkErrorAlert
